import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          {/* Back to Top Button */}
          <motion.button
            onClick={scrollToTop}
            className="mb-8 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full transition-all duration-200"
            whileHover={{ scale: 1.1, y: -2 }}
            whileTap={{ scale: 0.95 }}
          >
            <ArrowUp size={20} />
          </motion.button>

          {/* Main Footer Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-8"
          >
            <h3 className="text-2xl font-bold text-white mb-4">Meet Dobariya</h3>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Software Engineer & AI Enthusiast passionate about building innovative solutions 
              that make a difference in people's lives.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mb-8"
          >
            <div className="flex justify-center space-x-8 text-sm">
              <a href="#about" className="text-gray-400 hover:text-white transition-colors duration-200">
                About
              </a>
              <a href="#experience" className="text-gray-400 hover:text-white transition-colors duration-200">
                Experience
              </a>
              <a href="#projects" className="text-gray-400 hover:text-white transition-colors duration-200">
                Projects
              </a>
              <a href="#skills" className="text-gray-400 hover:text-white transition-colors duration-200">
                Skills
              </a>
              <a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-200">
                Contact
              </a>
              <a href="https://github.com/MeetDobariya275" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200">
                GitHub
              </a>
            </div>
          </motion.div>

          {/* Copyright */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="pt-8"
          >
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Meet Dobariya. All rights reserved.
            </p>

          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 